import { create } from 'zustand';

interface Methods {
  setLoading: (value: boolean) => void;
  setInputValue: (value: string) => void;
  resetStore: () => void;
}

interface Variables {
  isLoading: boolean;
  inputValue: string;
}

type StoreState = Variables & Methods;

const initialState: Variables = {
  isLoading: false,
  inputValue: '',
};

export const useDashboardLibraryContentLinkStore = create<StoreState>((set, get) => ({
  ...initialState,
  setLoading(isLoading) {
    set({ isLoading });
  },
  setInputValue(inputValue) {
    set({ inputValue });
  },
  resetStore() {
    set({ ...initialState });
  },
}));
